import { useAuth, useCities, useGuest } from '../state';

import { CityModel } from '@/services';
import shallow from 'zustand/shallow';

export const useCity = () => {
  const user = useAuth(s => s.user, shallow);
  const guest = useGuest(s => s.guest, shallow);
  const cities = useCities(s => s.cities, shallow);

  const cityId = user ? user.preferredCityId : guest ? guest.preferredCityId : null;

  const getCity = (cityId: number): CityModel => {
    return cities.citiesList.find(city => city.id === cityId);
  };

  return {
    cityId,
    getCity,
  };
};
